import z from 'zod';
import { t } from 'i18next';
import { lohnabrechnungsart } from './constants/lohnabrechnungsart';

export const LoginFormSchema = z.object({
  beraternummer: z
    .string()
    .trim()
    .min(1, {
      error: () => t('domain.datev.login.form.beraternummer.validationError'),
    })
    .max(7, {
      error: () =>
        t('domain.datev.login.form.beraternummer.validationErrorMaxLength'),
    }),
  mandantennummer: z
    .string()
    .trim()
    .min(1, {
      error: () => t('domain.datev.login.form.mandantennummer.validationError'),
    })
    .max(5, {
      error: () =>
        t('domain.datev.login.form.mandantennummer.validationErrorMaxLength'),
    }),
  lohnabrechnungsart: z.enum(Object.values(lohnabrechnungsart)),
});

export type LoginFormInput = z.input<typeof LoginFormSchema>;
